<template>
  <div>
    <div class="m-section" v-if="!loading">
      <div class="m-section__header">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-9 col-12">
            <div class="m-section__headline">
              Tus ingresos de Menú Diario
              <span
                class="m-section__date ml-2"
                v-if="getIncome.hasOwnProperty('labelDate')"
              >
                Del {{ getIncome.labelDate }}
              </span>
              <span
                class="m-section__date ml-2"
                v-if="getIncome.hasOwnProperty('week')"
              >
                <strong>|</strong>&nbsp; {{ getIncome.week }}
              </span>
            </div>
          </div>
          <div class="col-md-auto col-12">
            <div class="m-section__filter-date">
              Periodo:
              <span class="ml-1">
                <select
                  v-model="valWeek"
                  @change="changeWeek"
                  class="form-control w-auto"
                >
                  <option :value="0" disabled>Elige un Periodo</option>
                  <option
                    :value="item.value"
                    v-for="(item, index) in getWeeks"
                    :key="index"
                    >{{ item.label }}</option
                  >
                </select>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-6" v-if="getIncome.hasOwnProperty('orders')">
          <CardIncome
            :data="getIncome.orders"
            :name="'orders'"
            :action="true"
            :title="'Pedidos'"
            :url="'/pedidos'"
          />
        </div>
        <div class="col-md-3 col-6" v-if="getIncome.hasOwnProperty('debits')">
          <CardIncome
            :data="getIncome.debits"
            :name="'debits'"
            :action="true"
            :title="'Descuentos'"
            :url="'/espera-del-repartidor'"
            :currency="getIncome.currency"
          />
        </div>
        <div class="col-md-6 col-12" v-if="getIncome.hasOwnProperty('total')">
          <CardIncome
            :double="true"
            :data="getIncome.total"
            :name="'total'"
            :action="true"
            :title="'Ingresos'"
            :titleB="'Nivel de facturación:'"
            :date="getIncome.lastDateInvoicing"
            :week="getIncome.weeksLastInvoicing"
            :level="getIncome.levelInvoicing"
            :url="'/niveles'"
          />
        </div>
      </div>
    </div>
    <vue-content-loading
      v-else
      :width="300"
      :height="85"
      primary="#bdc3c7"
      secondary="#95a5a6"
    >
      <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="8" />
      <svg:rect x="90" y="0" rx="3" ry="3" width="50" height="8" />

      <svg:rect x="0" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="79" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="157" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="235" y="17" rx="3" ry="3" width="65" height="55" />
    </vue-content-loading>
  </div>
</template>
<script>
import { VueContentLoading } from "vue-content-loading";
import CardIncome from "@/components/Metrics/CardIncome";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    CardIncome,
    VueContentLoading
  },
  data: () => ({
    valWeek: "",
    loading: false
  }),
  computed: {
    ...mapGetters("metrics", ["getIncome", "getWeeks"])
  },
  methods: {
    ...mapActions("metrics", ["GET_METRIC"]),
    changeWeek(val) {
      this.valWeek = val.target.value;
      this.loading = true;
      this.GET_METRIC({
        week: this.valWeek
      })
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  }
};
</script>
